<ul>
  @for (breadcrumb of (breadcrumbs$ | async); track breadcrumb) {
    <li class="breadcrumb-item">
      <a [href]="breadcrumb.url" [ngClass]="{'latest': $last}">{{ breadcrumb.label }}</a>
    </li>
  }
</ul>
